import { Injectable } from '@angular/core';
import { GenericUtilityService } from '../generic/generic-utility.service';

import { insurenacecard, auth } from 'src/app/models/verifypatient/verifypatient';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ExitingpatientService {
  
  progress$: any;
  private progressObserver: any;
  private progress: any;
  constructor(private genericService:GenericUtilityService) { }
  
  VerifyExistingPatient(practice_code: any,Patient_account:any){
    return this.genericService.ApiGetMethodTalkphr("TalkCheckinPhaseTwo/VerifyExistingPatient?PracticeCode="+practice_code+"&PatientAccount="+Patient_account);
  }
  VerifyExistingPatientByNameDob(firstname: any,last_name:any,dob:any,practice_code:any){
    return this.genericService.ApiGetMethodTalkphr("TalkCheckinPhaseTwo/VerifyPatientByDOB?PracticeCode="+practice_code+"&FirstName="+firstname+"&LastName="+last_name+"&DOB="+dob);
  }
  VerifyMadisonpatient(verifyMadison:any){
    return this.genericService.ApiPostMethodTalkphr("MadisonMedical","GetPatientDetails", verifyMadison);
  }
  UpdateMadisonpatient(UpdateMadison:any){
    return this.genericService.ApiPostMethodTalkphr("MadisonMedical","UpdatePatientDemographics", UpdateMadison);
  }
  SignConsentForm(consentfom:any){
    
    return this.genericService.ApiPostMethodTalkphr("MadisonMedical","SaveConsentForm", consentfom);
  }
  InsuranceCardSave(data:any){
    
    return this.genericService.ApiPostMethodTalkphr("MadisonMedical","AddInsurance", data);
  }
  GetCheckinDetails(practice_code:any,Patient_account:any)
  {
    return this.genericService.ApiGetMethodTalkphr("TalkCheckinPhaseTwo/GetAppointmentDetails?PracticeCode="+practice_code+"&PatientAccount="+Patient_account);
  }
  SendOTP(obj: any) {
    return this.genericService.ApiPostMethodOTP('MultiFactorAuth', 'SendOTP', obj);
  }
  VerifyOTP(obj: any) {
    return this.genericService.ApiPostMethodOTP('MultiFactorAuth', 'VerifyOTP', obj);
  }
  getZip(zipcode: string, PATIENT_ACCOUNT: any, PRACTICE_CODE: any) {
    
    return this.genericService.ApiGetMethodTalkphr("MadisonMedical/ZipCityState?PracticeCode=" + PRACTICE_CODE + '&PatientAccount=' + PATIENT_ACCOUNT + '&ZipCode=' + zipcode);
  }
  insertSecureDocument(event:File[], data: insurenacecard) {
    return this.onInsertSecureMessagesUploadDocument(event, data);
}
private onInsertSecureMessagesUploadDocument(files: File[], data: insurenacecard): Observable<any> {

    return Observable.create((observer : any) => {
      
      let formData: FormData = new FormData(),
      xhr: XMLHttpRequest = new XMLHttpRequest();

      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            observer.next(JSON.parse(xhr.response));
            observer.complete();
          } else {
            observer.error(xhr.response);
          }
        }
      };

      xhr.upload.onprogress = (event) => {
        this.progress = Math.round(event.loaded / event.total * 100);
        if (this.progressObserver)
          this.progressObserver.next(this.progress);
      };

      //this.genericService.ApiPostMethodTalkphr("MadisonMedical","AddInsurance", data);

         xhr.open('POST', this.genericService.getBaseIpTalkPhr() + "api/MadisonMedical/AddInsurance", true); // For Live
     //   xhr.open('POST',   "https://uat-webservices.mtbc.com/breezeCheckinApi/api/MadisonMedical/AddInsurance", true); // For Staging
     //  xhr.open('POST',   "https://qa-webservices.mtbc.com/breezeCheckinApi/api/MadisonMedical/AddInsurance", true); // For testing


      formData.append("PatientAccount", data.PatientAccount);
      formData.append("PracticeCode", data.PracticeCode);
      formData.append("InsuranceType", data.InsuranceType);
    

      if(files == null){
        formData.append("InsuranceCard" , "");
      } else {
            Array.from(files).forEach((file) => 
            formData.append('InsuranceCard', file));
      }

       // AuthTokenwebServices
      xhr.setRequestHeader('Authorization', "Bearer " + localStorage.getItem("AuthTokenwebServices"));
      xhr.send(formData);
    });

  }

  GetPHIdEtails(data:any){
    
    return this.genericService.ApiPostMethodTalkphr("MadisonMedical","GetPhiAccessPermission", data);
  }
  SavePHIdetails(data:any){
    
    return this.genericService.ApiPostMethodTalkphr("MadisonMedical","SavePhiAccessPermission", data);
  }
  SaveInjurydetails (details: any){
  
    return this.genericService.ApiPostMethodTalkphr("MadisonMedical","ReasonForVisitQuestionnaire", details);

  }

}
